/* eslint-disable @typescript-eslint/no-unused-vars */
// import TicketMenuManagementCreate from "./lib/create";
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import TicketsTable from './lib/incidentsTable';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import TicketRequestsTable from './lib/requestsTable';
import * as S from './styles';
// import TicketCounts from './lib/ticketCounts';

export default function TicketsPage() {
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const { ticketsIncident, ticketsRequestItem } = useTypedSelector((state: any) => state.Tickets);
  const [active, setActive] = useState(location?.search.includes('request-item') ? 2 : 1);

  useEffect(() => {
    setActive(location?.search.includes('request-item') ? 2 : 1);
  }, [location]);

  return (
    <S.Container>
      <S.Head>
        <S.Title>Ticket System</S.Title>
        {/* <TicketCounts data={ticketStatistics.data} /> */}
      </S.Head>
      <Gap size="20px" />
      <S.Tab>
        <S.TabButton
          onClick={() => {
            setActive(1);
            setSearchParams('tab=incidents');
          }}
          className={active === 1 ? 'active' : ''}
        >
          Incidents
        </S.TabButton>
        <S.TabButton
          onClick={() => {
            setActive(2);
            setSearchParams('tab=request-item');
          }}
          className={active === 2 ? 'active' : ''}
        >
          Requests
        </S.TabButton>
      </S.Tab>
      {active === 1 ? (
        <TicketsTable
          data={ticketsIncident?.data}
          loading={ticketsIncident?.loading}
          infiniteScroll={true}
          error={ticketsIncident.error}
        />
      ) : (
        <TicketRequestsTable
          data={ticketsRequestItem?.data}
          loading={ticketsRequestItem?.loading}
          error={ticketsRequestItem?.error}
          infiniteScroll={true}
        />
      )}

      {/* <AppLoading loading={departments.loading || ticketCategory.loading || ticketStatistics.loading} /> */}
    </S.Container>
  );
}
